import React from "react";
import { BaseFile } from "react-keyed-file-browser";
import {
  Grid,
  TextField,
  IconButton,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/styles";
import { styles } from "./styles";
import { timeFormat, fileSizeFormat } from "../../utils/format";
import ActionMenu from "./actionMenu";
import CheckIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Cancel";
import validFilename from "valid-filename";

class TableFile extends BaseFile {
  constructor(props) {
    super(props);
    this.state = {
      isRenaming: false,
      newName: null,
      isValidName: true,
    };
    this.getNameColumn = this.getNameColumn.bind(this);
    this.submitRename = this.submitRename.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validFilename = this.validFilename.bind(this);
  }
  async submitRename() {
    const { rename, code, refresh } = this.props;
    const { newName } = this.state;
    await rename({
      name: newName,
      code,
    });
    await refresh();
    this.setState({ isRenaming: false });
  }

  onChange(event) {
    const { name, value } = event.target;
    const isValidName = this.validFilename(value);
    this.setState({ [name]: value, isValidName });
  }
  validFilename(name) {
    const { path } = this.props;
    return (
      this.props.checkDuplicatedName({ name, path }) && validFilename(name)
    );
  }
  getNameColumn() {
    const { isDraft, name, t } = this.props;
    const { isRenaming, newName, isValidName } = this.state;

    if (isRenaming || isDraft) {
      return (
        <Grid container alignItems="center">
          <TextField
            defaultValue={name || ""}
            value={newName}
            name="newName"
            onChange={this.onChange}
            helperText={
              isValidName ? t("valid_file_name") : t("invalid_file_name")
            }
            error={!isValidName}
          />
          <IconButton
            disabled={!isValidName}
            onClick={this.submitRename}
            color="primary"
          >
            <CheckIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              this.setState({ isRenaming: false });
            }}
            color="secondary"
          >
            <CancelIcon />
          </IconButton>
        </Grid>
      );
    } else {
      return (
        <a
          href="#e"
          onClick={(e) => {
            e.preventDefault();
          }}
          color="primary"
        >
          {name}
        </a>
      );
    }
  }
  render() {
    const {
      depth,
      browserProps,
      code,
      key,
      url,
      download,
      thumbnail,
      size,
      createdAt,
      name,
      relativeKey,
      rename,
      classes,
      getFileUrl,
    } = this.props;
    const { deleteFile } = browserProps;
    return (
      <TableRow>
        <TableCell
          style={{
            paddingLeft: depth + 1 + "rem",
          }}
          className={classes.tableCell}
        >
          <Grid container alignItems="center" wrap="nowrap">
            <img
              style={{
                marginRight: "0.5rem",
                borderRadius: "0.25rem",
              }}
              src={thumbnail || "./images/default-image-store.png"}
              height="60"
              width="90"
            />

            {this.getNameColumn()}
          </Grid>
        </TableCell>
        <TableCell className={classes.tableCell}>
          {fileSizeFormat(size)}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {timeFormat({ time: createdAt, format: "HH:mm:ss, DD/MM/YYYY" })}
        </TableCell>
        <TableCell className={classes.tableCell}>
          <ActionMenu
            preview={(event) => {
              this.handleItemClick(event);
              this.handleItemDoubleClick(event);
            }}
            remove={() => {
              deleteFile({
                code,
                key,
                url,
                download,
                thumbnail,
                size,
                createdAt,
                name,
                relativeKey,
              });
            }}
            allowRename={!rename ? false : true}
            allowView={true}
            allowRemove={true}
            rename={() => {
              this.setState({ isRenaming: true });
            }}
            getFileUrl={() => getFileUrl(url)}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default translate("translations")(withStyles(styles)(TableFile));
